export const MEDICAL_CONDITION_STATUSES = {
    WITH_MEDICAL_CONDITION: 'T',
    WITHOUT_MEDICAL_CONDITION: 'N',
    NOT_YET_DIAGNOSED: 'ND'
}
